// extracted by mini-css-extract-plugin
export var featuredEventCTA = "index-module--featuredEventCTA--jIHpZ";
export var featuredEventContainer = "index-module--featuredEventContainer--ArydR";
export var featuredEventContent = "index-module--featuredEventContent--WLVBY";
export var featuredEventContentBorderClass = "index-module--featuredEventContentBorderClass--psZPh";
export var featuredEventCountdownTimer = "index-module--featuredEventCountdownTimer--j-i8Z";
export var featuredEventCountdownTimerWrapper = "index-module--featuredEventCountdownTimerWrapper--KYCfE";
export var featuredEventDate = "index-module--featuredEventDate--I69x2";
export var featuredEventDateTime = "index-module--featuredEventDateTime--Q4glJ";
export var featuredEventDateTimeWrapper = "index-module--featuredEventDateTimeWrapper--cTdwP";
export var featuredEventDiffUnit = "index-module--featuredEventDiffUnit--1r2jl";
export var featuredEventImage = "index-module--featuredEventImage--9+yy0";
export var featuredEventImageClass = "index-module--featuredEventImageClass--wp-V6";
export var featuredEventMarginClass = "index-module--featuredEventMarginClass--WNb6e";
export var featuredEventMetadata = "index-module--featuredEventMetadata--bIjmW";
export var featuredEventTime = "index-module--featuredEventTime--pJIpI";
export var featuredEventWrapper = "index-module--featuredEventWrapper--QvlCZ";